import React, { useEffect, useRef, useState } from "react";
import { AddCircleOutline, Edit, Delete } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import MasterViewController from "../../redux/actions/masterApiActions";
import { Switch } from "@mui/material";

import ExportButton from "../../components/ag grid/ExportButton";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import usePermission from "../../utils/usePermission";
import { getUserInfoFromToken } from "../../utils/authUtils";
import ContractForm from "./AddContract";
import ContractViewController from "../../redux/actions/ContractApiAction";
import DownloadIcon from "@mui/icons-material/Download";

const ContractList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const [userType, setUserType] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editContract, setEditContract] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  const { contract} = useSelector((state) => state.contracts);
  const { getContract, deleteContract, downloadContractPdf } = ContractViewController();
  const { hasPermission } = usePermission();

  useEffect(() => {
    dispatch(getContract());
    const { userType } = getUserInfoFromToken();
    setUserType(userType);
  }, [dispatch]);

  const handleDelete = (id) => dispatch(deleteContract (id));
  const handleEdit = (contract) => {
    setEditContract(contract);
    setShowModal(true);
  };

  const columnDefs = [
    { headerCheckboxSelection: true, checkboxSelection: true, maxWidth: 50 },
    { headerName: "SR.No", valueGetter: (p) => p.node.rowIndex + 1, maxWidth: 80 },
    { headerName: "Employee", field: "employee_name", flex: 1 },
    { headerName: "Contract Type", field: "contract_type", flex: 1 },
    { headerName: "Start Date", field: "start_date", flex: 1 },
    { headerName: "End Date", field: "end_date", flex: 1 },
    {
  headerName: "Active",
  field: "is_active",
  flex: 1,
  cellRenderer: (params) => {
    return (
      <Switch
        checked={params.value}
        onChange={() => {
          const updated = { ...params.data, is_active: !params.value };
          // ✅ Dispatch update action
          dispatch(ContractViewController().updateContract(params.data.id, updated));
        }}
        color="primary"
      />
    );
  },
},

    {
      headerName: "Actions",
      pinned: "right",
      minWidth: 120,
      cellRenderer: (params) => (
        <div style={{ display: "flex", gap: 8 }}>
          {(userType === "Admin" || hasPermission("contract_managment", "edit")) && (
            <Tooltip title="Edit">
              <IconButton size="small" onClick={() => handleEdit(params.data)}>
                <Edit fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {hasPermission("contract_managment", "delete") && (
            <Tooltip title="Delete">
              <IconButton
                size="small"
                sx={{ color: "#d32f2f" }}
                onClick={() => handleDelete(params.data.id)}
              >
                <Delete fontSize="small" />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip title="Download Pdf">
                      <IconButton
                        color="primary"
                        size="small"
                         onClick={() => dispatch(downloadContractPdf(params.data.id))}
                      >
                        <DownloadIcon />
                      </IconButton>
                    </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="d-flex flex-wrap mb-3" style={{ justifyContent: "space-between" }}>
        <div className="mt-2">
          {(userType === "Admin" || hasPermission("contract_managment", "create")) && (
            <Button
              variant="contained"
              startIcon={<AddCircleOutline />}
              onClick={() => {
                setEditContract(null);
                setShowModal(true);
              }}
            >
              Add Contract
            </Button>
          )}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {(userType === "Admin" || hasPermission("contracts", "export")) && (
            <ExportButton
              gridRef={gridRef}
              fileName="contracts.xlsx"
              exportColumns={["employee", "contract_type"]}
              disabled={selectedRows.length === 0}
            />
          )}
          <PageSizeSelector pageSize={pageSize} onChange={(e) => setPageSize(Number(e.target.value))} />
        </div>
      </div>

      <div className="label-card">
        <Row>
          <Col><h3>Contract List</h3></Col>
        </Row>
      </div>

      <div className="list-grid-container" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={contract}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      <ContractForm
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editContract}
      />
    </div>
  );
};

export default ContractList;
